// not using named imports because SSR doesn't support it, https://github.com/michaelwittig/node-i18n-iso-countries/issues/270
import i18nIsoCountries from "i18n-iso-countries/index";
import br from "i18n-iso-countries/langs/br.json";
import de from "i18n-iso-countries/langs/de.json";
import en from "i18n-iso-countries/langs/en.json";
import es from "i18n-iso-countries/langs/es.json";
import fr from "i18n-iso-countries/langs/fr.json";
import id from "i18n-iso-countries/langs/id.json";
import it from "i18n-iso-countries/langs/it.json";
import ja from "i18n-iso-countries/langs/ja.json";
import ko from "i18n-iso-countries/langs/ko.json";
import nl from "i18n-iso-countries/langs/nl.json";
import pt from "i18n-iso-countries/langs/pt.json";
import tr from "i18n-iso-countries/langs/tr.json";
import zh from "i18n-iso-countries/langs/zh.json";

export default function useLocalisedCountryName() {
  const { locale } = useI18n();
  const loaded = ref(false);

  onMounted(() => {
    i18nIsoCountries.registerLocale(en);
    i18nIsoCountries.registerLocale(br);
    i18nIsoCountries.registerLocale(es);
    i18nIsoCountries.registerLocale(fr);
    i18nIsoCountries.registerLocale(nl);
    i18nIsoCountries.registerLocale(de);
    i18nIsoCountries.registerLocale(it);
    i18nIsoCountries.registerLocale(id);
    i18nIsoCountries.registerLocale(pt);
    i18nIsoCountries.registerLocale(ja);
    i18nIsoCountries.registerLocale(zh);
    i18nIsoCountries.registerLocale(tr);
    i18nIsoCountries.registerLocale(ko);
    loaded.value = true;
  });

  return {
    loaded,
    getName: (countryCode: string) => {
      return i18nIsoCountries.getName(countryCode, locale.value);
    },
  };
}
